import PdfAttach from "../../PageComponents/PdfAttach/PdfAttach";
import FormLabel from "../FormLabel/FormLabel";

const AttachCurrentlyAvailableBudget = ({
  onFilesSelect,
  totalFiles,
  maxFiles,
}) => {
  const storageKey = "currentlyAvailableBudgetFiles";
  return (
    <div style={{ marginBottom: "20px" }}>
      <FormLabel label={"Trenutno dostupan proračun projekta u PDF-u"} />
      <PdfAttach
        onFilesSelect={onFilesSelect}
        storageKey={storageKey}
        totalFiles={totalFiles}
        maxFiles={maxFiles}
      />
    </div>
  );
};

export default AttachCurrentlyAvailableBudget;
